// Centralized data-testid catalog for the Lifted Ecosystem shell.
export const HOME = { emergentLink: "home-emergent-link" };

export const AUTH = {
  loginForm: "auth-login-form",
  loginEmail: "auth-login-email-input",
  loginPassword: "auth-login-password-input",
  loginSubmit: "auth-login-submit-btn",
  loginError: "auth-login-error",
  registerForm: "auth-register-form",
  registerEmail: "auth-register-email-input",
  registerPassword: "auth-register-password-input",
  registerName: "auth-register-name-input",
  registerPhone: "auth-register-phone-input",
  registerSubmit: "auth-register-submit-btn",
  registerError: "auth-register-error",
  forgotForm: "auth-forgot-form",
  forgotEmail: "auth-forgot-email-input",
  forgotSubmit: "auth-forgot-submit-btn",
  forgotMessage: "auth-forgot-message",
  goRegister: "auth-go-register-link",
  goLogin: "auth-go-login-link",
  goForgot: "auth-go-forgot-link",
};

export const SHELL = {
  brand: "shell-brand-logo",
  userMenu: "shell-user-menu",
  userMenuName: "shell-user-name",
  logout: "shell-logout-btn",
  roleSwitcher: "shell-role-switcher",
  roleSwitcherOption: (role) => `shell-role-option-${role}`,
  navItem: (key) => `shell-nav-${key}`,
};

export const DASH = {
  root: "dashboard-root",
  greeting: "dashboard-greeting",
  primaryRole: "dashboard-primary-role-chip",
  permCount: "dashboard-permission-count",
  tile: (key) => `dashboard-tile-${key}`,
  tileLockedBadge: (key) => `dashboard-tile-locked-${key}`,
};

export const ADMIN = {
  usersTable: "admin-users-table",
  userRow: (id) => `admin-user-row-${id}`,
  editRolesBtn: (id) => `admin-edit-roles-btn-${id}`,
  roleCheckbox: (id, role) => `admin-role-cb-${id}-${role}`,
  saveRolesBtn: (id) => `admin-save-roles-btn-${id}`,
  cancelRolesBtn: (id) => `admin-cancel-roles-btn-${id}`,
  statusSelect: (id) => `admin-status-select-${id}`,
  rolesCatalog: "admin-roles-catalog",
  auditList: "admin-audit-list",
  auditRow: (id) => `admin-audit-row-${id}`,
  // Iter65 — manual add / delete / bulk
  addUserBtn: "admin-add-user-btn",
  addUserModal: "admin-add-user-modal",
  addUserEmail: "admin-add-user-email",
  addUserName: "admin-add-user-name",
  addUserRoleCb: (role) => `admin-add-user-role-${role}`,
  addUserSubmit: "admin-add-user-submit",
  addUserCancel: "admin-add-user-cancel",
  deleteUserBtn: (id) => `admin-delete-user-btn-${id}`,
  confirmDelete: "admin-confirm-delete",
  bulkCheckbox: (id) => `admin-bulk-cb-${id}`,
  bulkCheckAll: "admin-bulk-cb-all",
  bulkArchiveBtn: "admin-bulk-archive-btn",
  bulkConfirm: "admin-bulk-confirm",
};

export const MODULE = {
  page: (key) => `module-page-${key}`,
};

// ===========================================================================
// PHASE 4 — TRAINING
// ===========================================================================
export const TRAIN = {
  hub: "training-hub",
  trackCard: (key) => `training-track-${key}`,
  trackOpen: (key) => `training-track-open-${key}`,
  trackLocked: (key) => `training-track-locked-${key}`,

  modulesGrid: "training-modules-grid",
  moduleCard: (id) => `training-module-${id}`,
  moduleOpen: (id) => `training-module-open-${id}`,

  modulePage: "training-module-page",
  moduleTitle: "training-module-title",
  subcategoryCheckbox: (sid) => `training-subcat-${sid}`,
  completeModuleBtn: "training-module-complete-btn",
  noteTextarea: "training-note-textarea",
  noteSave: "training-note-save",
  questionInput: "training-question-input",
  questionSubmit: "training-question-submit",
  questionItem: (id) => `training-question-${id}`,

  certStartBtn: (track) => `training-cert-start-${track}`,
  certSubmitBtn: "training-cert-submit-btn",
  certScore: "training-cert-score",
  certPassed: "training-cert-passed",
  certVerificationCode: "training-cert-verification-code",

  trainerHub: "trainer-hub",
  trainerLearnerRow: (id) => `trainer-learner-${id}`,
  trainerLearnerOpen: (id) => `trainer-learner-open-${id}`,
  trainerQuestionRow: (id) => `trainer-question-${id}`,
  trainerAnswerInput: (id) => `trainer-answer-input-${id}`,
  trainerAnswerSubmit: (id) => `trainer-answer-submit-${id}`,
  trainerNoteInput: "trainer-note-input",
  trainerNoteSubmit: "trainer-note-submit",

  publicVerifyValid: "verify-valid",
  publicVerifyInvalid: "verify-invalid",
  publicVerifyName: "verify-name",
  publicVerifyTrack: "verify-track",
};

export const ADMIN_TRAIN = {
  home: "admin-training-home",
  tracksList: "admin-training-tracks",
  modulesList: "admin-training-modules",
  newModuleBtn: "admin-training-new-module",
  newModuleSave: "admin-training-new-module-save",
  moduleEdit: (id) => `admin-training-module-edit-${id}`,
  moduleDelete: (id) => `admin-training-module-delete-${id}`,

  codesList: "admin-codes-list",
  codeRow: (id) => `admin-code-row-${id}`,
  codeToggle: (id) => `admin-code-toggle-${id}`,
  codeDelete: (id) => `admin-code-delete-${id}`,
  codeCreateBtn: "admin-code-create-btn",
  codeCreateInput: "admin-code-create-input",

  certsList: "admin-certs-list",
  certRevoke: (id) => `admin-cert-revoke-${id}`,

  seminarsList: "admin-seminars-list",
  seminarCreate: "admin-seminars-create",

  announcementsList: "admin-announcements-list",
  announcementCreate: "admin-announcements-create",

  accessLogs: "admin-access-logs",
};

// ===========================================================================
// PHASE 5 — AFFILIATE
// ===========================================================================
export const AFF = {
  dashboard: "affiliate-dashboard",
  referralCode: "affiliate-referral-code",
  referralLink: "affiliate-referral-link",
  copyLinkBtn: "affiliate-copy-link",
  copyCodeBtn: "affiliate-copy-code",
  qrCode: "affiliate-qr-code",
  downloadQr: "affiliate-download-qr",
  shareTwitter: "affiliate-share-twitter",
  shareFacebook: "affiliate-share-facebook",
  shareWhatsapp: "affiliate-share-whatsapp",
  tierBadge: "affiliate-tier-badge",
  tierNext: "affiliate-tier-next",
  saveProfile: "affiliate-save-profile",
  taglineInput: "affiliate-tagline-input",
  bioInput: "affiliate-bio-input",

  publicHub: "public-affiliate-hub",
  publicName: "public-affiliate-name",
  publicTier: "public-affiliate-tier",
  publicCta: (slot) => `public-affiliate-cta-${slot}`,
  publicCertBadge: "public-affiliate-cert-badge",
};

export const ADMIN_AFF = {
  home: "admin-affiliate-home",
  profiles: "admin-affiliate-profiles",
  profileRow: (id) => `admin-affiliate-profile-${id}`,
  ledger: "admin-affiliate-ledger",
  ledgerRow: (id) => `admin-ledger-row-${id}`,
  approveBtn: (id) => `admin-ledger-approve-${id}`,
  voidBtn: (id) => `admin-ledger-void-${id}`,
  payouts: "admin-affiliate-payouts",
  config: "admin-commission-config",
  configSave: "admin-commission-config-save",
  configShopify: "admin-commission-config-shopify",
  configSupplies: "admin-commission-config-supplies",
  configPartner: "admin-commission-config-partner",
  configFranchise: "admin-commission-config-franchise",
  tiers: "admin-affiliate-tiers",
};

// ===========================================================================
// PHASE 6 — DELIVERY
// ===========================================================================
export const DELIVERY = {
  driverDashboard: "delivery-driver-dashboard",
  availabilityToggle: "delivery-availability-toggle",
  availableList: "delivery-available-list",
  availableRow: (id) => `delivery-available-${id}`,
  acceptBtn: (id) => `delivery-accept-${id}`,
  activeCard: "delivery-active-card",
  transitionBtn: (status) => `delivery-transition-${status}`,
  earningsList: "delivery-earnings",
  earningsRow: (id) => `delivery-earning-${id}`,
  profileSave: "delivery-profile-save",

  adminHome: "admin-delivery-home",
  dispatch: "admin-delivery-dispatch",
  pendingRow: (id) => `dispatch-pending-${id}`,
  assignBtn: (id) => `dispatch-assign-${id}`,
  assignSelect: (id) => `dispatch-assign-select-${id}`,
  driversList: "admin-delivery-drivers",
  driverRow: (id) => `admin-driver-${id}`,
  zonesList: "admin-delivery-zones",
  config: "admin-delivery-config",
  configBase: "admin-delivery-config-base",
  configPerMile: "admin-delivery-config-permile",
  configSave: "admin-delivery-config-save",
  earningsAdmin: "admin-delivery-earnings",
  earningsApprove: (id) => `admin-delivery-earning-approve-${id}`,
  ingestForm: "admin-delivery-ingest-form",
  ingestSubmit: "admin-delivery-ingest-submit",
};
